module.exports = "/fonts/vendor/primeicons/primeicons.eot?b0f5d02f4e70967dcc8162e938484366";